module.exports = __webpack_public_path__ + "img/pexels-alexander-ant-4585185.d26bd5e3.jpg";